module.exports = __webpack_public_path__ + "static/media/-_Cloud workforce .916f7bb2.png";